@if (vm(); as vm) {
    <div class="generic">
        <article class="generic__navigation" role="article" [ariaLabel]="vm.title + ' page'">
            <h2 class="generic__navigation-category category-heading">{{ vm.title }}</h2>
            @if (vm.subtitle) {
                <p class="body-0">{{ vm.subtitle }}</p>
            }
        </article>

        @if (vm.initialLoading) {
            <section class="skeleton-wrapper">
                <ng-container *ngTemplateOutlet="skeletonService.productListTemplate()"></ng-container>
            </section>
        } @else {
            @if (filterOptionsService) {
                <lib-product-list-filters
                    [initialValue]="initialFilters()"
                    (filtersChanged)="onFiltersChanged($event)"
                />
            }
            @if (!vm.products.length) {
                <ng-container *ngTemplateOutlet="emptyListTemplate()"></ng-container>
            } @else {
                <section class="generic__products">
                    @for (product of vm.products; track product.productId) {
                        <!-- RCP-441: wishlist disabled — removed binding: (toggleWishlist)="toggleWishlist.emit($event)" -->
                        <lib-product-list-card
                            [id]="product.productId"
                            class="products-card"
                            [isOutOfStock]="product.isOutOfStock"
                            [product]="product"
                            (addToCart)="addToCart.emit($event)"
                            (clickOnProduct)="onProductClick($event)"
                        />
                    }
                </section>
                <lib-see-more-items-button
                    [displayedCount]="vm.products.length"
                    [isLoading]="vm.isLoading"
                    [showPaginationCount]="vm.showPaginationCount"
                    [totalCount]="vm.totalCount"
                    (loadMore)="seeMoreProducts()"
                ></lib-see-more-items-button>
            }
        }
    </div>
}
